import { OpenThermStatusFlag } from 'openTherm';
import { BoilerAdapter } from '../06-boiler-adapter';
import { get_z3k_object_state } from '../../object/z3k-object';
import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet, setFlag } from 'z3k-parser/lib/flags';
export var HeatingCircuit;
(function (HeatingCircuit) {
    let Type;
    (function (Type) {
        Type[Type["BOILER"] = 0] = "BOILER";
        Type[Type["DHW"] = 1] = "DHW";
        Type[Type["COOLING"] = 2] = "COOLING";
        Type[Type["HEATING"] = 3] = "HEATING";
    })(Type = HeatingCircuit.Type || (HeatingCircuit.Type = {}));
    let Flags;
    (function (Flags) {
        Flags[Flags["USE_FOR_CONSUMER_MODE"] = 1] = "USE_FOR_CONSUMER_MODE";
        Flags[Flags["USE_FOR_CONSUMER_MODE_2"] = 2] = "USE_FOR_CONSUMER_MODE_2";
        Flags[Flags["IS_BOILER_CASCADE_FLAG"] = 4] = "IS_BOILER_CASCADE_FLAG";
        Flags[Flags["TURN_OFF_WHEN_DHW_FLAG"] = 8] = "TURN_OFF_WHEN_DHW_FLAG";
        Flags[Flags["ANTILEGIONELLA_FLAG"] = 16] = "ANTILEGIONELLA_FLAG";
        Flags[Flags["FLOW_DHW_TYPE"] = 32] = "FLOW_DHW_TYPE";
        Flags[Flags["CIRCUIT_DISABLE_FLAG"] = 64] = "CIRCUIT_DISABLE_FLAG";
        Flags[Flags["PZA_REQUEST_ONLY_MODE"] = 128] = "PZA_REQUEST_ONLY_MODE";
        Flags[Flags["IS_CIRCUIT_HIDDEN"] = 256] = "IS_CIRCUIT_HIDDEN";
        Flags[Flags["IS_ALWAYS_HEAT_REQUEST"] = 512] = "IS_ALWAYS_HEAT_REQUEST";
        Flags[Flags["DONT_USE__SEND_STATE_TO_ML_FLAG"] = 1024] = "DONT_USE__SEND_STATE_TO_ML_FLAG";
        Flags[Flags["DONT_USE__SEND_STATE_TO_USB_FLAG"] = 2048] = "DONT_USE__SEND_STATE_TO_USB_FLAG";
        Flags[Flags["ANTIFREEZE_LOGIC_DISABLE"] = 4096] = "ANTIFREEZE_LOGIC_DISABLE";
        Flags[Flags["EXT_THERMOSTAT_LOCK_MODE"] = 65536] = "EXT_THERMOSTAT_LOCK_MODE";
        Flags[Flags["NO_STOP_HEATING_WHEN_PID_IS_IN_LOW_THRESHOLD"] = 131072] = "NO_STOP_HEATING_WHEN_PID_IS_IN_LOW_THRESHOLD";
    })(Flags = HeatingCircuit.Flags || (HeatingCircuit.Flags = {}));
    let StatusFlags;
    (function (StatusFlags) {
        StatusFlags[StatusFlags["CIRCUIT_RUN_FLAG"] = 1] = "CIRCUIT_RUN_FLAG";
        StatusFlags[StatusFlags["CIRCUIT_LOCK_FLAG"] = 2] = "CIRCUIT_LOCK_FLAG";
        StatusFlags[StatusFlags["CIRCUIT_TURNED_OFF_FLAG"] = 4] = "CIRCUIT_TURNED_OFF_FLAG";
        StatusFlags[StatusFlags["CIRCUIT_SENSOR_FAULT_FLAG"] = 8] = "CIRCUIT_SENSOR_FAULT_FLAG";
        StatusFlags[StatusFlags["EXT_THERMOSTAT_IN_USE"] = 16] = "EXT_THERMOSTAT_IN_USE";
        StatusFlags[StatusFlags["EXT_THERMOSTAT_REQUEST"] = 32] = "EXT_THERMOSTAT_REQUEST";
        StatusFlags[StatusFlags["BOILER_RESERVE_FLAG"] = 64] = "BOILER_RESERVE_FLAG";
        StatusFlags[StatusFlags["CIRCUIT_IN_SUMMER_MODE"] = 128] = "CIRCUIT_IN_SUMMER_MODE";
        StatusFlags[StatusFlags["LEGIONELLA_RUN_FLAG"] = 256] = "LEGIONELLA_RUN_FLAG";
        StatusFlags[StatusFlags["BOILER_SCHEDULE_TURNED_OFF"] = 512] = "BOILER_SCHEDULE_TURNED_OFF";
        StatusFlags[StatusFlags["BOILER_ALWAYS_WORK"] = 1024] = "BOILER_ALWAYS_WORK";
        StatusFlags[StatusFlags["CONSUME_HEAT_REQUEST"] = 2048] = "CONSUME_HEAT_REQUEST";
        StatusFlags[StatusFlags["LEGIONELLA_TEMPERATURE_REACHED_FLAG"] = 4096] = "LEGIONELLA_TEMPERATURE_REACHED_FLAG";
        StatusFlags[StatusFlags["BOILER_CASCADE_FLAG"] = 8192] = "BOILER_CASCADE_FLAG";
    })(StatusFlags = HeatingCircuit.StatusFlags || (HeatingCircuit.StatusFlags = {}));
    let ConsumerMode;
    (function (ConsumerMode) {
        ConsumerMode[ConsumerMode["AIR"] = 0] = "AIR";
        ConsumerMode[ConsumerMode["AIR_PID"] = 1] = "AIR_PID";
        ConsumerMode[ConsumerMode["WATER"] = 2] = "WATER";
    })(ConsumerMode = HeatingCircuit.ConsumerMode || (HeatingCircuit.ConsumerMode = {}));
    let ControlMode;
    (function (ControlMode) {
        ControlMode[ControlMode["PZA"] = 1] = "PZA";
        ControlMode[ControlMode["AIR"] = 2] = "AIR";
        ControlMode[ControlMode["EXT_THERMOSTAT"] = 3] = "EXT_THERMOSTAT";
        ControlMode[ControlMode["WATER"] = 4] = "WATER";
    })(ControlMode = HeatingCircuit.ControlMode || (HeatingCircuit.ControlMode = {}));
    HeatingCircuit.HEAT_REQUEST__NO_REQUEST = 0;
    HeatingCircuit.HEAT_REQUEST__CONSTANT = 2730;
    HeatingCircuit.HEAT_REQUEST__MAX_BOILER_TEMP = 0xffff; //65535
    HeatingCircuit.TARGET_BOILER_TEMPERATURE_REQUEST = 0xff00; //65280
    function statusFlagSet(state, flag) {
        if (state.status == null)
            return false;
        return (state.status & flag) !== 0;
    }
    HeatingCircuit.statusFlagSet = statusFlagSet;
    function isUseExtThermostat(state) {
        return statusFlagSet(state, StatusFlags.EXT_THERMOSTAT_IN_USE);
    }
    HeatingCircuit.isUseExtThermostat = isUseExtThermostat;
    function isRequestWarmFromExtThermostat(state) {
        return statusFlagSet(state, StatusFlags.EXT_THERMOSTAT_REQUEST);
    }
    HeatingCircuit.isRequestWarmFromExtThermostat = isRequestWarmFromExtThermostat;
    function isSummerMode(state) {
        return statusFlagSet(state, StatusFlags.CIRCUIT_IN_SUMMER_MODE);
    }
    HeatingCircuit.isSummerMode = isSummerMode;
    function isFail(state) {
        return statusFlagSet(state, StatusFlags.CIRCUIT_SENSOR_FAULT_FLAG);
    }
    HeatingCircuit.isFail = isFail;
    function isWorking(state) {
        return state.worktime > 0 || statusFlagSet(state, StatusFlags.CIRCUIT_RUN_FLAG);
    }
    HeatingCircuit.isWorking = isWorking;
    function isTurnedOff(state) {
        return statusFlagSet(state, StatusFlags.CIRCUIT_TURNED_OFF_FLAG);
    }
    HeatingCircuit.isTurnedOff = isTurnedOff;
    function isBoilerReserve(state) {
        return statusFlagSet(state, StatusFlags.BOILER_RESERVE_FLAG);
    }
    HeatingCircuit.isBoilerReserve = isBoilerReserve;
    function getConsumerMode(hc) {
        return hc.setting_register & 0x03;
    }
    HeatingCircuit.getConsumerMode = getConsumerMode;
    function setConsumerMode(hc, mode) {
        return {
            ...hc,
            setting_register: (hc.setting_register & ~0x03) | mode,
        };
    }
    HeatingCircuit.setConsumerMode = setConsumerMode;
    function isAirConsumerMode(hc) {
        return getConsumerMode(hc) === ConsumerMode.AIR;
    }
    HeatingCircuit.isAirConsumerMode = isAirConsumerMode;
    function isAirPIDConsumerMode(hc) {
        return getConsumerMode(hc) === ConsumerMode.AIR_PID;
    }
    HeatingCircuit.isAirPIDConsumerMode = isAirPIDConsumerMode;
    function isWaterConsumerMode(circuit) {
        return (HeatingCircuit.getConsumerMode(circuit) ===
            HeatingCircuit.ConsumerMode.WATER);
    }
    HeatingCircuit.isWaterConsumerMode = isWaterConsumerMode;
    function isEnabled(hc) {
        return !isFlagSet(hc, Flags.CIRCUIT_DISABLE_FLAG);
    }
    HeatingCircuit.isEnabled = isEnabled;
    function isHidden(hc) {
        return isFlagSet(hc, Flags.IS_CIRCUIT_HIDDEN);
    }
    HeatingCircuit.isHidden = isHidden;
    function setEnabled(hc, enabled) {
        return setFlag(hc, Flags.CIRCUIT_DISABLE_FLAG, !enabled);
    }
    HeatingCircuit.setEnabled = setEnabled;
    function isBlockedWhileDHW(hc) {
        return isFlagSet(hc, Flags.TURN_OFF_WHEN_DHW_FLAG);
    }
    HeatingCircuit.isBlockedWhileDHW = isBlockedWhileDHW;
    function setBlockedWhileDHW(hc, block_enabled) {
        return setFlag(hc, Flags.TURN_OFF_WHEN_DHW_FLAG, block_enabled);
    }
    HeatingCircuit.setBlockedWhileDHW = setBlockedWhileDHW;
    function isAntilegEnabled(hc) {
        return isFlagSet(hc, Flags.ANTILEGIONELLA_FLAG);
    }
    HeatingCircuit.isAntilegEnabled = isAntilegEnabled;
    function isAntilegTurnOn(hc) {
        return isFlagSet(hc, StatusFlags.LEGIONELLA_RUN_FLAG);
    }
    HeatingCircuit.isAntilegTurnOn = isAntilegTurnOn;
    function setAntilegEnabled(hc, antileg_enabled) {
        return setFlag(hc, Flags.ANTILEGIONELLA_FLAG, antileg_enabled);
    }
    HeatingCircuit.setAntilegEnabled = setAntilegEnabled;
    function isFlowDHW(hc) {
        return isFlagSet(hc, Flags.FLOW_DHW_TYPE);
    }
    HeatingCircuit.isFlowDHW = isFlowDHW;
    function setFlowDHW(hc, is_flow_dhw) {
        return setFlag(hc, Flags.FLOW_DHW_TYPE, is_flow_dhw);
    }
    HeatingCircuit.setFlowDHW = setFlowDHW;
    function isAlwaysHeatRequest(hc) {
        return isFlagSet(hc, Flags.IS_ALWAYS_HEAT_REQUEST);
    }
    HeatingCircuit.isAlwaysHeatRequest = isAlwaysHeatRequest;
    function setAlwaysHeatRequest(hc, always) {
        return setFlag(hc, Flags.IS_ALWAYS_HEAT_REQUEST, always);
    }
    HeatingCircuit.setAlwaysHeatRequest = setAlwaysHeatRequest;
    function getControlModeClimatic(hc) {
        if (hc.external_thermostat) {
            return ControlMode.EXT_THERMOSTAT;
        }
        if (isWaterConsumerMode(hc)) {
            if (hc.pza !== 0xff) {
                return ControlMode.PZA;
            }
            else {
                return ControlMode.WATER;
            }
        }
        else {
            if (isAirConsumerMode(hc) || isAirPIDConsumerMode(hc)) {
                return ControlMode.AIR;
            }
        }
        throw 'Unknown Heating Circuit Control Mode in heating_circuit_get_control_mode()';
    }
    HeatingCircuit.getControlModeClimatic = getControlModeClimatic;
    function isAntiFreezeDisabled(circuit) {
        return isFlagSet(circuit, Flags.ANTIFREEZE_LOGIC_DISABLE);
    }
    HeatingCircuit.isAntiFreezeDisabled = isAntiFreezeDisabled;
    function setAntiFreezeDisabled(circuit, enabled) {
        return setFlag(circuit, Flags.ANTIFREEZE_LOGIC_DISABLE, !enabled);
    }
    HeatingCircuit.setAntiFreezeDisabled = setAntiFreezeDisabled;
    function isControlByWater(hc) {
        return (HeatingCircuit.isBoiler(hc) ||
            (HeatingCircuit.isConsumer(hc) && HeatingCircuit.isWaterConsumerMode(hc)));
    }
    HeatingCircuit.isControlByWater = isControlByWater;
    function isBoiler(hc) {
        return hc.type === Type.BOILER;
    }
    HeatingCircuit.isBoiler = isBoiler;
    function isDHW(hc) {
        return hc.type === Type.DHW;
    }
    HeatingCircuit.isDHW = isDHW;
    function isConsumer(hc) {
        return hc.type === Type.HEATING;
    }
    HeatingCircuit.isConsumer = isConsumer;
    function isCooling(hc) {
        return hc.type === Type.COOLING;
    }
    HeatingCircuit.isCooling = isCooling;
    function isNoStopHeatingWhenPidIsInLowThreshold(hc) {
        return isFlagSet(hc, Flags.NO_STOP_HEATING_WHEN_PID_IS_IN_LOW_THRESHOLD);
    }
    HeatingCircuit.isNoStopHeatingWhenPidIsInLowThreshold = isNoStopHeatingWhenPidIsInLowThreshold;
    function setNoStopHeatingWhenPidIsInLowThreshold(hc, no_stop) {
        return setFlag(hc, Flags.NO_STOP_HEATING_WHEN_PID_IS_IN_LOW_THRESHOLD, no_stop);
    }
    HeatingCircuit.setNoStopHeatingWhenPidIsInLowThreshold = setNoStopHeatingWhenPidIsInLowThreshold;
    function isPZARequestOnlyMode(hc) {
        return isFlagSet(hc, Flags.PZA_REQUEST_ONLY_MODE);
    }
    HeatingCircuit.isPZARequestOnlyMode = isPZARequestOnlyMode;
    function setPZARequestOnlyMode(hc, requestOnlyMode) {
        return setFlag(hc, Flags.PZA_REQUEST_ONLY_MODE, requestOnlyMode);
    }
    HeatingCircuit.setPZARequestOnlyMode = setPZARequestOnlyMode;
    function isCircuitWithBoilerAdapter(boiler_adapters_ids, hc) {
        return ((isBoiler(hc) || isDHW(hc)) &&
            hc.control_devices.some((obj_id) => boiler_adapters_ids.includes(obj_id)));
    }
    HeatingCircuit.isCircuitWithBoilerAdapter = isCircuitWithBoilerAdapter;
    function hasPZA(hc) {
        return ![
            0, //HeatingMode.OFF_MODE,
            255, //HeatingMode.RESERVE_MODE,
            null,
        ].includes(hc.pza);
    }
    HeatingCircuit.hasPZA = hasPZA;
    /**
     * @function
     * Контур потребителя с типом управления "по теплоносителю"
     * В нём назначена ПЗА-кривая
     * Не стоит галочка "ПЗА только для запроса тепла"
     * Это тип "По теплоносителю с опцией ПЗА" - из инструкции к ПЗА
     * (https://zont-online.ru/ftpgetfile.php?id=300&module=files)
     * @param hc - кусочек контура, в котором есть setting_register и pza
     * @return boolean
     */
    function isAirIndication(hc) {
        return (getConsumerMode(hc) === ConsumerMode.WATER &&
            hasPZA(hc) &&
            !isPZARequestOnlyMode(hc));
    }
    HeatingCircuit.isAirIndication = isAirIndication;
    // DEPRECATED
    function isCascade(hc) {
        return isFlagSet(hc, Flags.IS_BOILER_CASCADE_FLAG);
    }
    HeatingCircuit.isCascade = isCascade;
    function setCascadeFlag(hc, is_cascade) {
        return setFlag(hc, Flags.IS_BOILER_CASCADE_FLAG, is_cascade);
    }
    HeatingCircuit.setCascadeFlag = setCascadeFlag;
    /**
     * @function
     * Отображаем греет ли котёл этот контур
     * !!!!!!!!!!!!!!!!ДЛЯ Baxi CONNECT+ !!!!!!!!!!!!!!!!!!!!!!!!!!
     * 1. Определяем какого типа контур
     * 2. Запрашиваем состояние бойлера
     * 3. Если есть нужные флаги, то показываем
     * @param hc - контур
     * @param ba - адаптер котла
     * @param state - Z3k-состояние
     * @return boolean
     */
    function showFlame(hc, ba, state) {
        //Контуры охлаждения греть не можем
        if (isCooling(hc)) {
            return false;
        }
        //Если нет адаптера или это котловой контур
        if (isBoiler(hc) || ba == null) {
            const hc_state = get_z3k_object_state(state, hc.id);
            return hc_state != null ? isWorking(hc_state) : false;
        }
        const ba_work_state = BoilerAdapter.getWorkState(ba, state);
        if (ba_work_state != null) {
            //Если адаптер в ошибке
            if (ba_work_state.includes(OpenThermStatusFlag.f)) {
                return false;
            }
            if (isConsumer(hc)) {
                return (ba_work_state.includes(OpenThermStatusFlag.ch) &&
                    ba_work_state.includes(OpenThermStatusFlag.fl));
            }
            if (isDHW(hc)) {
                return (ba_work_state.includes(OpenThermStatusFlag.dhw) &&
                    ba_work_state.includes(OpenThermStatusFlag.fl));
            }
        }
        return false;
    }
    HeatingCircuit.showFlame = showFlame;
    function isExtThermostatLockMode(hc) {
        return isFlagSet(hc, Flags.EXT_THERMOSTAT_LOCK_MODE);
    }
    HeatingCircuit.isExtThermostatLockMode = isExtThermostatLockMode;
    function setExtThermostatLockMode(hc, checked) {
        return setFlag(hc, Flags.EXT_THERMOSTAT_LOCK_MODE, checked);
    }
    HeatingCircuit.setExtThermostatLockMode = setExtThermostatLockMode;
    function changeExtThermostat(hc, ext_therm_id) {
        if (ext_therm_id == null) {
            return {
                ...setExtThermostatLockMode(hc, false),
                external_thermostat: ext_therm_id,
            };
        }
        return { ...hc, external_thermostat: ext_therm_id };
    }
    HeatingCircuit.changeExtThermostat = changeExtThermostat;
    /**
     * @function
     * Обнуляем запрос тепла для проточного ГВС
     * @param hc - кусочек контура, в котором есть setting_register
     * @return HeatingCircuit
     */
    function zeroHeatRequest(hc) {
        if (isFlowDHW(hc)) {
            return { ...hc, heat_request: HeatingCircuit.HEAT_REQUEST__NO_REQUEST, heat_source: null };
        }
        return hc;
    }
    HeatingCircuit.zeroHeatRequest = zeroHeatRequest;
    /**
     * @function
     * Обнуляем запрос тепла для проточного ГВС
     * @param boiler_adapters_ids - кусочек контура, в котором есть setting_register
     * @param hc - кусочек контура, в котором есть setting_register
     * @param type - новый тип контура
     * @return HeatingCircuit
     */
    function changeHcType(boiler_adapters_ids, hc, type) {
        let new_hc = { ...hc, type };
        //Был не потребителем или стал котлом
        if (!isConsumer(hc) || isBoiler(new_hc)) {
            new_hc = { ...new_hc, air_temp_sensor: null, air_temp_sensor_reserve: null };
        }
        //Стал ГВС
        if (isDHW(new_hc)) {
            new_hc = {
                ...new_hc,
                water_temp_sensor: null,
                water_temp_sensor_reserve: null,
                dhw_temp_sensor: null,
                dhw_temp_sensor_reserve: null,
                water_min_temperature: 20,
                water_max_temperature: 85,
            };
            if (!isCircuitWithBoilerAdapter(boiler_adapters_ids, hc)) {
                new_hc = setFlowDHW(new_hc, false);
            }
        }
        if (!isDHW(new_hc) && !isConsumer(new_hc)) {
            new_hc = {
                ...new_hc,
                heat_request: HeatingCircuit.HEAT_REQUEST__NO_REQUEST,
                heat_source: null,
            };
        }
        if (!isDHW(new_hc)) {
            new_hc = setAntilegEnabled(setFlowDHW(new_hc, false), false);
        }
        // для чего это? -> https://git.microline.ru/zont/server/-/issues/578
        if (!isConsumer(new_hc)) {
            new_hc = setAlwaysHeatRequest(new_hc, false);
        }
        // https://git.microline.ru/zont/server/-/issues/673
        if (!isBoiler(new_hc) && !isDHW(new_hc)) {
            new_hc = {
                ...new_hc,
                control_devices: new_hc.control_devices.filter((id) => !boiler_adapters_ids.includes(id)),
            };
        }
        return new_hc;
    }
    HeatingCircuit.changeHcType = changeHcType;
    HeatingCircuit.get = createAccessors(arrayGetSet('heating_circuits'), {
        name: 'контур отопления',
        type: 0,
        water_min_temperature: 15,
        water_max_temperature: 30,
        air_temp_sensor: null,
        air_temp_sensor_reserve: null,
        water_temp_sensor: null,
        water_temp_sensor_reserve: null,
        hysteresis: 0.5,
        control_devices: [],
        setting_register: 0,
        turn_off_delay: 0,
        external_thermostat: null,
        heat_request: 0,
        heat_source: null,
        summer_threshold: 0,
        winter_summer_switch: false,
        pza: null,
        dhw_temp_sensor: null,
        dhw_temp_sensor_reserve: null,
        antileg_mode_options: {
            h: 0,
            m: 0,
            days: 0,
        },
        position: 0,
        locker_id: null,
        delta_temp: 0,
        is_new: true,
    });
})(HeatingCircuit || (HeatingCircuit = {}));
